/**
 * Centralized tree-shaken ECharts setup.
 *
 * Import only the chart types and components we use to minimize bundle size.
 * All chart files should import from this module instead of 'echarts' directly.
 */

import * as echarts from 'echarts/core'

// Chart types
import { BarChart } from 'echarts/charts'
import { LineChart } from 'echarts/charts'
import { PieChart } from 'echarts/charts'
import { ScatterChart } from 'echarts/charts'
import { BoxplotChart } from 'echarts/charts'
import { GraphChart } from 'echarts/charts'
import { CustomChart } from 'echarts/charts'
import { HeatmapChart } from 'echarts/charts'
import { RadarChart } from 'echarts/charts'
import { SankeyChart } from 'echarts/charts'

// Components
import { GridComponent } from 'echarts/components'
import { TooltipComponent } from 'echarts/components'
import { LegendComponent } from 'echarts/components'
import { ToolboxComponent } from 'echarts/components'
import { DataZoomComponent } from 'echarts/components'
import { MarkLineComponent } from 'echarts/components'
import { MarkPointComponent } from 'echarts/components'
import { TitleComponent } from 'echarts/components'
import { GraphicComponent } from 'echarts/components'
import { DatasetComponent } from 'echarts/components'
import { TransformComponent } from 'echarts/components'
import { VisualMapComponent } from 'echarts/components'
import { MarkAreaComponent } from 'echarts/components'

// Renderer
import { CanvasRenderer } from 'echarts/renderers'

// Register everything
echarts.use([
  BarChart,
  LineChart,
  PieChart,
  ScatterChart,
  BoxplotChart,
  GraphChart,
  CustomChart,
  HeatmapChart,
  RadarChart,
  SankeyChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  ToolboxComponent,
  DataZoomComponent,
  MarkLineComponent,
  MarkPointComponent,
  TitleComponent,
  GraphicComponent,
  DatasetComponent,
  TransformComponent,
  VisualMapComponent,
  MarkAreaComponent,
  CanvasRenderer,
])

export default echarts
